// src/context/site/apexChange.js
//
// The registrable-domain comparison behind the site-edit warning.
//
// ⚠️ The FE owns this warning: PUT /website-site does NOT refuse and does NOT
// re-crawl, so a domain change silently leaves the URL list and the index on
// the OLD site until the next [Ricarica contenuti] — which will then answer
// 409 SITE_APEX_CHANGED and ask to REPLACE the list. Warn on a domain change,
// not on a path or scheme tweak. This is a heuristic, not the Public Suffix
// List: the server is the guard, this only decides whether to show a dialog.

const SECOND_LEVEL = new Set(['co', 'com', 'org', 'net', 'gov', 'edu', 'ac']);

/** "https://www.blog.acme.co.uk/x" → "acme.co.uk"; null when not a URL. */
export function registrableDomain(url) {
  let host;
  try {
    host = new URL(url).hostname.toLowerCase();
  } catch {
    return null;
  }
  const labels = host.split('.').filter(Boolean);
  if (labels.length <= 2) return labels.join('.');
  const take = SECOND_LEVEL.has(labels[labels.length - 2]) ? 3 : 2;
  return labels.slice(-take).join('.');
}

/**
 * True only when BOTH sides resolve to a domain and they differ. A first
 * connect (old side null / sentinel) never warns.
 */
export function isApexChange(oldUrl, newUrl) {
  const a = registrableDomain(oldUrl);
  const b = registrableDomain(newUrl);
  if (!a || !b) return false;
  return a !== b;
}
